// ============================================
// Creator State - Creations & Stats (Zustand 기반)
// ============================================

import { useCreatorStore } from '../../../stores/creatorStore.js';

// ============================================
// 제작물 목록 상태
// ============================================

export const getCurrentCreations = () => useCreatorStore.getState().currentCreations;
export const getCurrentFilter = () => useCreatorStore.getState().currentFilter;
export const getCurrentSort = () => useCreatorStore.getState().currentSort;
export const getIsLoadingCreations = () => useCreatorStore.getState().isLoadingCreations;

export function setCurrentCreations(creations) {
  useCreatorStore.getState().setCurrentCreations(creations);
}

export function setCurrentFilter(filter) {
  useCreatorStore.getState().setCurrentFilter(filter);
}

export function setCurrentSort(sort) {
  useCreatorStore.getState().setCurrentSort(sort);
}

export function setIsLoadingCreations(loading) {
  useCreatorStore.getState().setIsLoadingCreations(loading);
}

// ============================================
// 통계 상태
// ============================================

export const getCurrentStatsCreationId = () => useCreatorStore.getState().currentStatsCreationId;
export const getCurrentStatsPeriod = () => useCreatorStore.getState().currentStatsPeriod;

export function setCurrentStatsCreationId(id) {
  useCreatorStore.getState().setCurrentStatsCreationId(id);
}

export function setCurrentStatsPeriod(period) {
  useCreatorStore.getState().setCurrentStatsPeriod(period);
}
